"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionSelfEnum = void 0;
var PermissionSelfEnum;
(function (PermissionSelfEnum) {
    PermissionSelfEnum["None"] = "n";
    PermissionSelfEnum["Self"] = "s";
    PermissionSelfEnum["All"] = "a";
})(PermissionSelfEnum = exports.PermissionSelfEnum || (exports.PermissionSelfEnum = {}));
